import React, { useEffect, useState } from "react";
import { hot } from "react-hot-loader";
import { connect } from "dva";
import {
  Select,
  Tag,
  Icon,
  Input,
  Spin,
  notification,
  Button,
  Row,
  Col
} from "antd";
import {
  RequirementsApi,
  RequirementProfilesApi
} from "../../services/generated-sdk";
// import { handleError } from "../../utils/common";
// import { useStateValue } from "../TestCaseManage_aggrid/context";
// import { hasPermission } from "../Roles/common";
import { AppContext } from "../../AppContext";
const Option = Select.Option;
import * as _ from "lodash";

function RequirementAutocompleteStatic({
  projectId,
  onChange,
  value,
  initialValue,
  style = {},
  requirementsEnabled = false,
  disabled = false
}) {
  const { loggedInUser, planDetails } = React.useContext(AppContext);
  const [requirements, setRequirements] = useState([]);
  // const { projectRequirements } = useStateValue();
  // const [loading, setloading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [searchCompleted, setSearchCompleted] = useState(false);
  // let selectRef = React.createRef();
  const [requirementInput, setRequirementInput] = useState("");
  const [selectedRequirements, setSelectedRequirements] = useState([]);
  // const [showAddModal, setshowAddModal] = useState(false);
  // const [newRequirementTitle, setNewRequirementTitle] = useState(false);
  const [requirement, setRequirement] = useState("");
  const selectRef = React.useRef(null);

  const canShowRequirements = _.get(
    _.find(_.get(planDetails, "features", []), { name: "requirements" }),
    "allowed"
  );
  let reqSelect: Select | null = null;

  // const canManageRequirements = hasPermission(
  //   loggedInUser,
  //   "manageRequirements"
  // );

  const fetchRequirements = async () => {
    return;
    // if (loading) {
    //   return;
    // }
    // setloading(true);
    // try {
    //   const api = new RequirementsApi();
    //   const result = await api.getRequirements({
    //     project: projectId,
    //     limit: 500
    //   });
    //   setRequirements(result);
    //   setloading(false);
    // } catch (e) {
    //   console.log({ fetchRequirements_error: e });
    //   setloading(false);
    // }
  };

  useEffect(
    () => {
      // fetchRequirements();
      if (value && Array.isArray(value) && value.length && value[0].id) {
        // console.log("for edit case to populate existing req in autocomplete......");
        setRequirements(value);
      }
      setSelectedRequirements(value && value.length > 0 ? value : initialValue);
    },
    [projectId, value, initialValue]
  );
  // useEffect(() => {
  //   // return () => {
  //   //   window.removeEventListener('keydown');
  //   // };
  // });

  if (!projectId) {
    return <span>Project ID not set!</span>;
  }

  const onSelectChange = opts => {
    setSelectedRequirements(opts);
    onChange(opts);
  };

  const searchRequirements = async e => {
    let searchValue = requirementInput;
    // console.log({ "start searching for ": searchValue });
    if (searching) {
      return false;
    }
    if (
      !searchValue ||
      !searchValue.trim().length ||
      searchValue.trim().length < 2
    ) {
      return false;
    }
    try {
      setSearching(true);
      // setloading(true);
      const api = new RequirementProfilesApi();
      let result = await api.searchRequirementIssues({
        project: projectId,
        filter: JSON.stringify({
          searchValue: searchValue.trim()
        })
      });
      setRequirements(result);
      setSearchCompleted(true);
      let autocompElem = document.getElementById("req_auto_comp_elem");
      if (autocompElem) {
        autocompElem.click();
      }
      setSearching(false);
      // setloading(false);
    } catch (e) {
      console.log({ error_searching_req: e });
      if (e.json) {
        e.json().then(data => {
          console.log(data.message);
          setSearchCompleted(true);
        });

        setRequirements([]);
        setSearchCompleted(true);
        let autocompElem = document.getElementById("req_auto_comp_elem");
        if (autocompElem) {
          autocompElem.click();
        }
        // } else {
        //   notification.warn({ message: "Something went wrong" });
      }
      setSearching(false);
      // setloading(false);
      setRequirements([]);
    }
    return false;
  };

  return (
    <div>
      <Row>
        <Col span={20}>
          <Select
            notFoundContent={
              searchCompleted &&
              requirementInput.length &&
              !requirements.length ? (
                <span>No result found for {requirementInput}</span>
              ) : null
            }
            loading={searching}
            id="req_auto_comp_elem"
            filterOption={(input, option) => {
              // console.log({ input, option });
              // setRequirement(input);
              if (
                option.props.children &&
                Array.isArray(option.props.children) &&
                option.props.children.length
              ) {
                if (
                  option.props.children[0]
                    .toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                ) {
                  return true;
                }
                if (
                  option.props.children[2]
                    .toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                ) {
                  return true;
                }
              }
              return false;
            }}
            // ref={selectRef}
            // defaultOpen={true}
            // showSearch={true}
            // ref={node => {
            //   reqSelect = node;
            // }}
            onInputKeyDown={e => {
              // setRequirementInput(e.currentTarget.value);
              if (e.keyCode === 9 || e.keyCode === 13) {
                e.preventDefault();
                searchRequirements(e);
              }
            }}
            onSearch={e => {
              setSearchCompleted(false);
              setRequirementInput(e);
            }}
            placeholder={
              searching
                ? `Searching for "${requirementInput}"`
                : requirementsEnabled === true
                  ? "Select Requirement or type to add a new Requirement"
                  : canShowRequirements
                    ? "Requirements are not enabled"
                    : "To enable requirements, upgrade to Premium"
            }
            value={
              selectedRequirements && selectedRequirements.length
                ? selectedRequirements
                    .map(req => (req && req.id ? req.id : req ? req : null))
                    .filter(r => r != null)
                : []
            }
            defaultValue={initialValue}
            onChange={onSelectChange}
            mode="multiple"
            style={{ width: "100%", ...style }}
            disabled={!requirementsEnabled ? true : disabled ? true : false} // || !canManageRequirements
          >
            {requirements.map((requirement, i) => (
              <Option value={requirement.id} key={requirement.id}>
                {requirement.requirementKey} - {requirement.title}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={4}>
          <Button
            // shape="circle"
            // icon="search"
            style={{
              marginLeft: "10px"
            }}
            type="primary"
            htmlType="button"
            onClick={searchRequirements}
            loading={searching}
            disabled={requirementInput.length < 2 ? true : false}
          >
            Search
          </Button>
        </Col>
      </Row>
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    // projectId: state.app.projectId
  };
}

const RequirementAutocomplete = connect(mapStateToProps)(
  RequirementAutocompleteStatic
);

export default hot(module)(RequirementAutocomplete);
